import React from 'react'
import BGBlock from './BGBlock'
import { AiOutlineTag } from "@react-icons/all-files/ai/AiOutlineTag";
import { FaRegHandshake } from "@react-icons/all-files/fa/FaRegHandshake";
import PicCont from './PicCont';
import trust from '../public/Pictures/trust.png'
import percentage from '../public/Pictures/percentage.png'
import bill from '../public/Pictures/bill.png'
import analytics from '../public/Pictures/analytics.png'
import white from '../public/Pictures/model2_header.jpg'
import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";

const B2BModelTwo = ({summary}) => {

  return <section className='b2bModel'  id='model2' >
{!summary &&    <BGBlock src={white} >
        <div className="row">
            <FaRegHandshake /> <h2>Audio Visual Partners</h2>
        </div>
    </BGBlock>}
    <div className="partOne">

        <strong className="bTitle">{summary ? 'Audio Visual Partners' :'What is it?'}</strong>
        <p>
        Streamlined <strong>commission system</strong> easy to manage through the Partner Portal.<br/><br/>
        Venue Partner featured page. Dedicated account manager, customized AV packages.<br/><br/>
        New relevant source of <strong>highly qualified leads</strong>.
        </p>
    </div>
    <div className="partTwo">
        <strong className="bTitle">How does it work?</strong>
        <div className="row">
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={trust}  />
                <strong className="cTitle bold">Two way partnership</strong>
                </div>
            <div className="divP">
                <p>
                The venue registers on our platform as part of our <strong>Venue Partners</strong>. When a client books an AV service from us in that venue (referred or not), our partner <strong>automatically gains a commission.</strong> <br/><br/>
                 Our partners are also listed on our Venue Partnerships section and benefit from our <strong>high qualified leads</strong>.
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={bill}  />
                <strong className="cTitle bold">Easy Partnership & commision management</strong>
                </div>
            <div className="divP second">
                <p>
                Through our <strong>Partner Portal</strong>, we notify partners when a client places an order. They gain easy access to all the information: status of every pending sale for their venue, order information, referrals, accumulated commissions and transaction history.<br/><br/>                
                The dedicated <strong>Account Manager</strong> centralizes and assists all the aspects of the relationship between our partner and Miami Sound Rental.
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={analytics}  />
                <strong className="cTitle bold">Customized AV Solutions</strong>
                </div>
            <div className="divP">
                <p>
                Bespoke <strong>AV advisory service</strong>, we deploy our experts to the venue to craft <strong>customized packages for each room sizes and types</strong>. Our assessment provides a set of tailor made packages (6-10) that are delivered on an unbranded booklet with QR codes that directly link with the Package Page. All the packages are shown in the Venue Partnerships Page.<br /><br />
We provide our <strong>techology platform and digital tools</strong> at the service of the partner: Online setup builder to edit or create new packages, equipment inventory updated in real time, quick quoting service, white labeled estimates, etc. 
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={percentage}  />
                <strong className="cTitle bold">Commission Schedule</strong>
                </div>
            <div className="divP last">
                <p>
                Progressive commission schedule based on volume of sales for the previous month:<br/><br/>
                <div className='discountRow'><strong>First Month:</strong><span className='discount'>20% Commission</span> </div><br/>
                 
                <div className='discountRow headRow'><strong>After fist month:</strong><span className='discount'>Commission</span> </div><br/>
                <div className='discountRow'><span>Less than <strong>$10,000</strong> in sales:</span><span className='discount'>10%</span> </div>
                <div className='discountRow'><span>Between <strong>$10,000</strong> and <strong>$30,000</strong> in sales:</span><span className='discount'>20%</span> </div>
                <div className='discountRow'><span>More than <strong>$30,000</strong> in sales:</span><span className='discount'>30%</span> </div><br/>
                <strong>Commissions are directly applied to the venue</strong> in each order.
                </p>
                </div>
            </div>
        </div>
    </div>
    <div className="partThree">
        <strong className="bTitle">How does it benefit your business?</strong>
        <div className='row'>
            <div className="point">
                <strong className='pointTitle'><IoIosArrowForward /> Easy referrals, easy way of gaining commissions</strong>
                <p>
                This model allows the partner to earn high commissions without any extra effort. By simply registering as part of our partner program, our technology will <strong>automatically associate an event with a venue</strong> and generate the commission.
                </p>
            </div>
            <div className="point ">
                <strong className='pointTitle'><IoIosArrowForward /> Partner portal: one stop shop to manage everything related to the partnership and dedicated account manager</strong>
                <p>
                Through the Partner Portal, the venue will have easy access to all relevant information to manage everything related to the partnership. He will have access to tools to maximize results and monetize the relationship on your own or with the assistance of your dedicated account manager when required.
                </p>
            </div>
            <div className="point">
                <strong className='pointTitle'><IoIosArrowForward /> Seamless integrated partnership operations</strong>
                <p>
                Our integrated system simplifies operations, from communication between team members to managing <strong>commissions and accounting processes</strong>, making it effortless for our partners to make the most out of the partnership.
                </p>
            </div>
            <div className="point last">
                <strong className='pointTitle'><IoIosArrowForward /> New source of high volume of qualified traffic and leads </strong>
                <p>
                Benefit of being part of our Venue Partnerships section. As <strong>digital sales leaders in AV services in South Florida</strong>, we have the maximum coverage of internet searches related to audiovisual material for event production. Our platform has over 3,000 monthly visits from qualified leads by interest and geographic location.</p>
            </div>
        </div>
    </div>

  </section>
}

export default B2BModelTwo